import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import callReducer from './slices/callSlice';
import cartReducer from './slices/cartSlice';
import deliveryReducer from './slices/deliverySlice';
import deliverymanReducer from './slices/deliverymanSlice';
import menuReducer from './slices/menuSlice';
import locationReducer from './slices/locationSlice';
import agentReducer from './slices/agentSlice';
import checkinReducer from './slices/checkinSlice';
import feedbackReducer from './slices/feedbackSlice';
import statsReducer from './slices/statsSlice';
import trendsReducer from './slices/trendsSlice';
import uiReducer from './slices/uiSlice';
import playerReducer from './slices/playerSlice';
import printerReducer from './slices/printerSlice';
import tableReducer from './slices/tableSlice';
import { socketMiddleware } from './middleware/socketMiddleware';
import { cartMiddleware } from './middleware/cartMiddleware';
import { feedbackMiddleware } from './middleware/feedbackMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    call: callReducer,
    cart: cartReducer,
    delivery: deliveryReducer,
    deliveryman: deliverymanReducer,
    menu: menuReducer,
    location: locationReducer,
    agent: agentReducer,
    checkin: checkinReducer,
    feedback: feedbackReducer,
    stats: statsReducer,
    trends: trendsReducer,
    ui: uiReducer,
    player: playerReducer,
    printer: printerReducer,
    table: tableReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false })
      .concat(socketMiddleware)
      .concat(cartMiddleware)
      .concat(feedbackMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
